<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar
      :background-color="sidebarBackground"
    >
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Users',
            custom_icon: '/img/icons/nav-user.svg',
            path: '/users'
          }"
        />
        <sidebar-item
          :link="{
            name: 'Subscribers',
            custom_icon: '/img/icons/nav-user.svg',
            path: '/subscribers'
          }"
        />
        <sidebar-item
          :link="{
            name: 'Products',
            custom_icon: '/img/icons/nav-product-bottle.svg',
            path: '/products'
          }"
        />
        <sidebar-item
          :link="{
            name: 'Materials',
            custom_icon: '/img/icons/nav-product-bottle.svg',
            path: '/materials'
          }"
        />
        <sidebar-item
          :link="{
            name: 'Supplier',
            custom_icon: '/img/icons/nav-product-bottle.svg',
            path: '/supplier'
          }"
        />
        <sidebar-item
          :link="{
            name: 'Categories',
            custom_icon: '/img/icons/nav-product-bottle.svg',
            path: '/categories'
          }"
        />
        <sidebar-item :link="{
            name: 'Sales Orders',
            custom_icon: '/img/icons/file.svg',
            path: '/sales-orders'
          }"
        />
        <sidebar-item :link="{
            name: 'Sales Reports',
            custom_icon: '/img/icons/file.svg',
            path: '/sales-reports'
          }"
        />
        <sidebar-item :link="{
            name: 'Purchase Orders',
            custom_icon: '/img/icons/file.svg',
            path: '/purchase-orders'
          }"
        />
        <sidebar-item :link="{
            name: 'Notifications',
            custom_icon: '/img/icons/file.svg',
            path: '/notifications'
          }"
        />
        <sidebar-item :link="{
            name: 'Change password',
            custom_icon: '/img/icons/file.svg',
            path: '/password-change'
          }"
        />
      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
    </div>
  </div>
</template>
<script>
  import DashboardNavbar from './DashboardNavbar.vue';
  import { FadeTransition } from 'vue2-transitions';

  export default {
    components: {
      DashboardNavbar,
      FadeTransition
    },
    data() {
      return {
        sidebarBackground: 'vue' //vue|blue|orange|green|red|primary
      };
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      }
    }
  };
</script>
<style lang="scss">
</style>
